import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { useState } from "react";
import { CustomersList, QuickView } from "./components";
import { CustomersFilters } from "./components/CustomersFilters";
import { Customer, CustomersSorting, Tag } from "./models";
import { CardSearch } from "@arelia-components/ui-atoms/CardSearch";
import { useCustomersList as useFilteredCustomers } from "./hooks";

type Props = {
  customers: Customer[];
}

export default function CustomersPresenter({ customers }: Props) {
  const [activeCustomer, setActiveCustomer] = useState<Customer | null>(customers[0]);
  const [sortCustomersBy, setSortCustomersBy] = useState(CustomersSorting.createdDateDesc);
  const [searchValue, setSearchValue] = useState('');
  const [includeTestUsers, setIncludeTestUsers] = useState(false);
  const [selectedTags, setSelectedTags] = useState<Tag[]>([]);

  const filteredCustomers = useFilteredCustomers(customers, sortCustomersBy, searchValue, includeTestUsers, selectedTags);

  return (
    <>
      <CustomersFilters
        sortCustomersBy={sortCustomersBy}
        setSortCustomersBy={setSortCustomersBy}
        includeTestUsers={includeTestUsers}
        setIncludeTestUsers={setIncludeTestUsers}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
      />
      <Box sx={styles.listBox}>
        <Card sx={styles.listCard}>
          <CardHeader
            title="Customers"
            sx={styles.listCardHeader}
            action={<CardSearch value={searchValue} onChange={setSearchValue} />} />
          <CardContent>
            {filteredCustomers.length === 0 && searchValue
              ? <Typography variant="subtitle2">No data match search request.</Typography>
              : <CustomersList
                customers={filteredCustomers}
                activeCustomer={activeCustomer}
                setActiveCustomer={setActiveCustomer} />}
          </CardContent>
        </Card>
        {activeCustomer && <Card sx={styles.detailsBox}>
          <CardHeader title="Quick view" />
          <CardContent>
            <QuickView activeCustomer={activeCustomer} />
          </CardContent>
        </Card>}
      </Box>
    </>
  );
}

const styles = {
  listBox: {
    display: "flex",
    gap: "22px",
    alignItems: "flex-start"
  },
  listCard: {
    flex: 1
  },
  listCardHeader: {
    marginBottom: "32px"
  },
  detailsBox: {
    width: "356px",
    position: "sticky",
    top: 0
  }
}